import React, { useEffect, useState } from "react";
import PopupWrapper from "../popupWrapper/popupWrapper";
import { popupTexts } from "../../utils/constants";
import "./acceptPopup.css";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateOrderStatusAsync } from "../../redux/reducers/orderStatus";
import { fetchOrderDetailsAsync } from "../../redux/reducers/customerAgentDetailsDashboard";

const AcceptPopup = ({ onClose, setToast }) => {
  const { id } = useParams();
  const customerInfo = JSON.parse(localStorage.getItem("customerInfo"));
  const updatedCustomerInfo = {
    ...customerInfo,
    status: "COMPLETED",
  };
  const customerDashboardData = useSelector(
    (state) => state?.customerAgentDetails?.orderDetails
  );
  const { orderStatusData } = useSelector((state) => state.orderStatus);
  const dispatch = useDispatch();

  const handleAccept = () => {
    const statusPayload = { orderId: id, status: "COMPLETED" };
    dispatch(updateOrderStatusAsync(statusPayload)).then((res) => {
      if (res?.payload) {
        dispatch(fetchOrderDetailsAsync(id));
      }
    });
  };

  useEffect(() => {
    if (
      orderStatusData?.customer_support_agent_info &&
      orderStatusData?.reseller_agent_info
    ) {
      localStorage.setItem("customerInfo", JSON.stringify(updatedCustomerInfo));
      setToast({
        header: "Plan Accepted",
        message: "We have accepted your plan",
      });
      onClose();
      setTimeout(() => {
        setToast(null);
      }, 3000);
    }
  }, [orderStatusData]);

  return (
    <PopupWrapper className="accept_popup" onClose={onClose}>
      <p className="accept_header">
        {customerDashboardData?.status?.toLowerCase() === "cancelled"
          ? popupTexts.warning_header
          : popupTexts.accept_header}
      </p>
      {customerDashboardData?.status?.toLowerCase() === "cancelled" && (
        <p className="warning_subheader">{popupTexts.warning_subheader}</p>
      )}
      <div className="button_section">
        <button className="button reject reject_btn " onClick={onClose}>
          {popupTexts.cancel_btn}
        </button>
        <button className="button accept accept_btn " onClick={handleAccept}>
          {popupTexts.confirm_btn}
        </button>
      </div>
    </PopupWrapper>
  );
};

export default AcceptPopup;
